import {
  MAX_SELECTED_NODES_PER_SCRIPT,
  type AIRequest,
  type AIResponse,
  type ApiResponse,
} from '@bandos/shared'
import { HttpClient } from '../../../services/api/client'
import { TokenManager } from '../../../services/auth/tokenManager'

/**
 * Frontend client for batch validation question generation.
 * Calls the unified AI process endpoint with operation 'generate_batch_validation'.
 */
export class ValidationService {
  /** Generate batch validation questions for multiple selected nodes */
  static async generateBatchValidation(
    mindmapId: string,
    method: 'survey' | 'interview',
    nodeIds: string[],
    targetDurationMinutes?: number,
    language?: string
  ): Promise<ApiResponse<AIResponse>> {
    if (nodeIds.length > MAX_SELECTED_NODES_PER_SCRIPT) {
      return {
        data: null,
        error: {
          message: `Too many nodes selected: ${nodeIds.length}. The limit is ${MAX_SELECTED_NODES_PER_SCRIPT} per script.`,
          code: 'TOO_MANY_NODES',
        },
      }
    }

    const headers = await TokenManager.getAuthHeaders()

    if (!headers.Authorization) {
      return {
        data: null,
        error: {
          message: 'Authentication required. Please log in.',
          code: 'AUTH_REQUIRED',
        },
      }
    }

    const requestData: AIRequest = {
      mindmapId,
      operation: 'generate_batch_validation',
      nodeIds,
      method,
      targetDurationMinutes,
      language,
    }

    return HttpClient.post<AIResponse>('/ai/process', requestData, headers)
  }
}
